var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enableTool
    ? _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("control-printvisible", {
            attrs: {
              moduleCode: _vm.moduleCode,
              panelID: _vm.pageID,
              posBtnMap: _vm.mapButtons.print_visible_emissions.position,
              idxBtnMap: _vm.mapButtons.print_visible_emissions.order,
              showLabelBtnMap: _vm.mapButtons.print_visible_emissions.showLabel,
              collapsible: _vm.mapButtons.print_visible_emissions.collapsible,
              collapsed: _vm.initialCollapsedExpandCollapse,
              showButtonOnActionMap: _vm.showButtonOnActionMap,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }